function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeTypeSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CurrentBusinessUnitSelector } from 'invision-core/src/components/session/businessunit.selectors';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { BillCycleDetailsSelector } from '../../../reducers/selectors/customer.billcycle.selectors';
import { retrieveBillCycleDetails } from '../../../reducers/actions/customer.billcycle.actions';
import { ADJUSTMENT_DUE_DAYS, CUSTOMER_CATEGORY, PAYMENT_DUE_DAYS, SUBSCRIBER_ADJUSTMENT_DUE_DAYS_LIMITS, SUBSCRIBER_PAYMENT_DUE_DAYS_LIMITS } from '../../createCustomerPopup/create.customer.popup.constants';
import { CanUserUpdateBillingDetailsSelector, SelectedCustomerCategorySelector } from '../../../reducers/selectors/customer.selectors';
import { findAccountingMethodBasedOnBu } from './billing.information.section.helper';
import { ACCOUNTING_METHODS, DEFAULT_ACCOUTNING_METHOD_CODE } from './billing.information.section.constants';
export var BillingInformationSectionController = /*#__PURE__*/function () {
  function BillingInformationSectionController($ngRedux) {
    _classCallCheck(this, BillingInformationSectionController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      ACCOUNTING_METHODS: ACCOUNTING_METHODS,
      CoreLocaleKeys: CoreLocaleKeys,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      handleAdjustmentDueDaysChange: this.handleAdjustmentDueDaysChange.bind(this),
      handlePaymentDueDaysChange: this.handlePaymentDueDaysChange.bind(this),
      setDefaultAccountingMethod: this.setDefaultAccountingMethod.bind(this),
      subscriberAdjustmentDueDaysLimits: SUBSCRIBER_ADJUSTMENT_DUE_DAYS_LIMITS,
      subscriberPaymentDueDaysLimits: SUBSCRIBER_PAYMENT_DUE_DAYS_LIMITS
    });
  }
  return _createClass(BillingInformationSectionController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          accountingMethod: MetadataCodeTypeSelector(CODES.Accounting, store),
          billCycleDetails: BillCycleDetailsSelector(store),
          canUserUpdateBillingDetails: CanUserUpdateBillingDetailsSelector(store),
          convergentBillerBehaviorConfig: MetadataCodeTypeSelector(CODES.ConvergentBillerBehaviorConfig, store),
          currentBusinessUnit: CurrentBusinessUnitSelector(store),
          customerCategory: SelectedCustomerCategorySelector(store),
          subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store)
        };
      };
      var controllerActions = {
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        retrieveBillCycleDetails: retrieveBillCycleDetails
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.setSubscriberPaymentDueDays();
      this.defaultAccountingMethod = findAccountingMethodBasedOnBu(this.state.accountingMethod);
      this.selectedDefaultAccountingMethod = this.customerModel.SubscriberTypeDetails.AccountingMethod ? this.ACCOUNTING_METHODS[this.customerModel.SubscriberTypeDetails.AccountingMethod] : this.ACCOUNTING_METHODS[this.extractDefaultAccountingMethodValue()];
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "extractDefaultAccountingMethodValue",
    value: function extractDefaultAccountingMethodValue() {
      return this.defaultAccountingMethod.find(function (accountingMethod) {
        return accountingMethod.Key === DEFAULT_ACCOUTNING_METHOD_CODE;
      }).Value;
    }
  }, {
    key: "handleAdjustmentDueDaysChange",
    value: function handleAdjustmentDueDaysChange(updatedAdjustmentDueDays) {
      this.customerModel.SubscriberTypeDetails.AdjustmentDueDays = updatedAdjustmentDueDays;
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "handlePaymentDueDaysChange",
    value: function handlePaymentDueDaysChange(updatedPaymentDueDays) {
      this.customerModel.SubscriberTypeDetails.PaymentDueDays = updatedPaymentDueDays;
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "requirements",
    get: function get() {
      if (this.state) {
        return this.state.customerCategory === CUSTOMER_CATEGORY.COMMERCIAL ? this.state.subscriberCategoryRequirements : this.state.subscriberRequirements;
      } else {
        return {};
      }
    }
  }, {
    key: "setSubscriberPaymentDueDays",
    value: function setSubscriberPaymentDueDays() {
      var _this$state$convergen, _convergentBillerDefa, _convergentBillerDefa2;
      var convergentBillerDefaultConfig = ((_this$state$convergen = this.state.convergentBillerBehaviorConfig) === null || _this$state$convergen === void 0 ? void 0 : _this$state$convergen.length) && (this.state.convergentBillerBehaviorConfig.find(function (config) {
        return !config.Global;
      }) || this.state.convergentBillerBehaviorConfig.find(function (config) {
        return config.Global;
      }));
      var convergentBillerBehaviorConfigPaymentDueDays = convergentBillerDefaultConfig === null || convergentBillerDefaultConfig === void 0 ? void 0 : (_convergentBillerDefa = convergentBillerDefaultConfig.AdditionalProperties.find(function (additionalProperties) {
        return additionalProperties.Key === PAYMENT_DUE_DAYS;
      })) === null || _convergentBillerDefa === void 0 ? void 0 : _convergentBillerDefa.Value;
      var convergentBillerBehaviorConfigAdjustmentDueDays = convergentBillerDefaultConfig === null || convergentBillerDefaultConfig === void 0 ? void 0 : (_convergentBillerDefa2 = convergentBillerDefaultConfig.AdditionalProperties.find(function (additionalProperties) {
        return additionalProperties.Key === ADJUSTMENT_DUE_DAYS;
      })) === null || _convergentBillerDefa2 === void 0 ? void 0 : _convergentBillerDefa2.Value;
      var defaultPaymentDueDays = this.requirements && this.requirements.default_payment_due_days.length ? this.requirements.default_payment_due_days : convergentBillerBehaviorConfigPaymentDueDays;
      var defaultAdjustmentDueDays = this.requirements && this.requirements.default_adjustment_due_days.length ? this.requirements.default_adjustment_due_days : convergentBillerBehaviorConfigAdjustmentDueDays;
      if (this.customerModel && this.customerModel.SubscriberTypeDetails) {
        this.paymentDueDays = this.customerModel.SubscriberTypeDetails.PaymentDueDays !== null ? this.customerModel.SubscriberTypeDetails.PaymentDueDays : convertStringToNumber(defaultPaymentDueDays);
        this.adjustmentDueDays = this.customerModel.SubscriberTypeDetails.AdjustmentDueDays !== null ? this.customerModel.SubscriberTypeDetails.AdjustmentDueDays : convertStringToNumber(defaultAdjustmentDueDays);
      }
    }
  }, {
    key: "setDefaultAccountingMethod",
    value: function setDefaultAccountingMethod(updatedAccountingMethod) {
      this.selectedDefaultAccountingMethod = this.customerModel.SubscriberTypeDetails.AccountingMethod;
      this.customerModel.SubscriberTypeDetails.AccountingMethod = updatedAccountingMethod.value;
      this.onFormChanged()(this.customerModel);
    }
  }]);
}();
export default {
  template: require('./billing.information.section.html'),
  bindings: {
    customerModel: '<',
    isAccountingMethodReadonly: '<?',
    isCreditCheckPopup: '<?',
    isFormSubmitted: '<',
    isNewConnect: '<',
    isNewCustomer: '<',
    onFormChanged: '&'
  },
  require: {
    parentForm: '^form'
  },
  controller: BillingInformationSectionController,
  controllerAs: 'BillingInformationSection'
};